import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wag_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getSessionId = () => {
  let s = localStorage.getItem("wag_chat_session");
  if (!s) {
    s = `wag-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("wag_chat_session", s);
  }
  return s;
};
